import styles from './styles/message-box.module.css';

import {ReactComponent as Reload} from '../../assets/docs-women/reload.svg';

export default function MessageBox({ height, Icon, message, subMessage, handleReload }) {
    return (
        <div
            className={styles.wrapper}
            datatype={message}
            style={{ height: height }}
        >
            <Icon />
            <div>{message}</div>
            {subMessage === '재시도'
                ? <button onClick={handleReload}>{subMessage} <Reload /></button>
                : <div>{subMessage}</div>
            }
        </div>
    );
}